// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"App_menuContainer_3Uulj"};